import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { TipsAndUpdatesOutlinedIcon } from '@uplift/icons';
import { Alert } from '../../../Alert';
import React from 'react';

export type ProgressNoteAlertProps = {
  title: string;
  children: React.ReactNode;
};

export const ProgressNoteAlert: React.FC<ProgressNoteAlertProps> = ({ title, children }) => {
  const { classes } = useStyles();

  return (
    <Alert
      severity="info"
      showIcon={false}
      classes={{ title: classes.alertTitle }}
      title={(
        <>
          <Box className={classes.titleIcon}>
            <TipsAndUpdatesOutlinedIcon fontSize="inherit" />
          </Box> {title}
        </>
      )}
    >
      {children}
    </Alert>
  );
};

const useStyles = makeStyles()((theme) => ({
  alertTitle: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.4px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  titleIcon: {
    display: 'inline-flex',
    backgroundColor: theme.palette.info.main,
    color: theme.palette.common.white,
    borderRadius: '50%',
    padding: '4px',
    fontSize: '12px',
  },
}));
